import { Box } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Button } from "#components/atoms/Button/Button";
import { Divider } from "#components/atoms/Divider/Divider";
import { Text } from "#components/atoms/Typographies/Text";
import { Flex } from "#shared/view/components/Flex";

type Props = {
  onOpenMailClient: () => void;
  subject: string;
  body: string;
};

export const MessageTemplatePreview = ({ onOpenMailClient, subject, body }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex
      gap={0}
      justify="center"
      direction="column"
      align="center"
      style={{
        background: colors.bg.elevation.tertiary,
        borderRadius: radius.md,
      }}
    >
      <Flex
        align="center"
        justify="space-between"
        gap={spacing[3]}
        style={{
          padding: spacing[4],
          alignSelf: "stretch",
        }}
      >
        <Text size="small" type="medium">
          {t("quoteRequestLine.actions.exportConsultation.modal.messageTemplate.label")}
        </Text>
        <Button
          variant="tertiary"
          size="sm"
          leftSection={<IconMail size={16} />}
          onClick={onOpenMailClient}
        >
          {t("quoteRequestLine.actions.exportConsultation.modal.messageTemplate.openMailClient")}
        </Button>
      </Flex>
      <Divider style={{ alignSelf: "stretch" }} />
      <Box
        style={{
          maxHeight: 712,
          overflowY: "auto",
          padding: spacing[4],
          alignSelf: "stretch",
        }}
      >
        <Text size="small" type="bold">
          {t("quoteRequestLine.actions.exportConsultation.modal.messageTemplate.subjectLabel")}:{" "}
          {subject}
        </Text>
        <Text
          size="small"
          color={colors.text.secondaryDefault}
          style={{ whiteSpace: "pre-wrap", marginTop: spacing[2] }}
        >
          {body}
        </Text>
      </Box>
    </Flex>
  );
};
